<template>
  <v-card
    class="product-group-density mx-auto pa-2"
    outlined
  >

    <v-list-item >
      <v-list-item-content class="overflow-visible">
        <v-list-item-title class="headline mb-2">
          Tỷ trọng doanh thu từng nhóm sản phẩm
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    
    <div
      v-if="densityReport.totalData !== 0"
    >
      <chartist 
        ratio="ct-major-second"
        type="Pie"
        :data="densityReport"
        :options="chartOptions"
      >
      </chartist>

      <ul class="description">
        <li v-for="(item, index) in densityReport.groupName" :key="index">
          <v-avatar
            tile
            v-bind:style="{'background-color':densityReport.color[index % 10]}"
            size="20"
          />
          {{item}}
        </li>
      </ul>
    </div>
    <common-no-result
      v-if="densityReport.totalData == 0 || Object.entries(densityReport).length == 0"
    />
    
  </v-card>
</template>

<script>
import * as ChartistTooltips from 'chartist-plugin-tooltips';

  export default {
    props: {
      densityReport: {
        default: () => ({})
      },
    },
    data () {
      return {
        chartOptions: {
          height: 300,
          plugins: [this.$chartist.plugins.tooltip({
            transformTooltipTextFnc: (e) => {
             return e + '%'
            }
          })]
        },
      }
    },
    created() {
    },
    methods: {
    },
  }
</script>

<style lang="scss">
  .ct-major-second {
    svg {
      position: relative;
    }
    &:before {
      padding-bottom: 0;
    }
  }

  .product-group-density {
    .ct-series-a .ct-slice-pie {
      fill: teal;
    }

    .ct-series-b .ct-slice-pie {
      fill: royalblue;
    }
    
    .ct-series-c .ct-slice-pie {
      fill: darkgrey;
    }

    .ct-series-d .ct-slice-pie {
      fill: red;
    }

    .ct-series-e .ct-slice-pie {
      fill: yellow;
    }

    .ct-series-f .ct-slice-pie {
      fill: hotpink;
    }

    .ct-series-g .ct-slice-pie {
      fill: aqua;
    }

    .ct-series-h .ct-slice-pie {
      fill: gold;
    }
    
    .ct-series-i .ct-slice-pie {
      fill: blueviolet;
    }
    
    .ct-series-j .ct-slice-pie {
      fill: maroon;
    }

    .ct-label {
      fill: white;
    }
  }
</style>